// extracted by mini-css-extract-plugin
module.exports = {"order_price":"OrderPrice_order_price__3PqjE","label":"OrderPrice_label__bvIxO","value":"OrderPrice_value__3ibKn"};